import { DISPATCH_TYPE, IMPORT_STATUS } from "../utils/enums.js";
import {
  IClientType,
  ICombination,
  IFAQ,
  IImportDate,
  IKeyword,
  IQuestionType,
  ISection
} from "@/types/SPTypes.tsx";
import { ImportActionTypes } from "@/actionTypes/importActionTypes.ts";

interface ImportState {
  clientTypes: IClientType[];
  combinations: ICombination[];
  FAQs: IFAQ[];
  keywords: IKeyword[];
  importStatus: IMPORT_STATUS;
  sections: ISection[];
  questionTypes: IQuestionType[];
  importDate: IImportDate[] | null;
}

const initialState = {
  clientTypes: [],
  combinations: [],
  FAQs: [],
  keywords: [],
  importStatus: IMPORT_STATUS.NONE,
  sections: [],
  questionTypes: [],
  importDate: null
};

function importReducer(
  state: ImportState = initialState,
  action: ImportActionTypes
): ImportState {
  switch (action.type) {
    case DISPATCH_TYPE.SET_IMPORT_CLIENT_TYPES:
      return { ...state, clientTypes: action.payload };
    case DISPATCH_TYPE.SET_IMPORT_COMBINATIONS:
      return { ...state, combinations: action.payload };
    case DISPATCH_TYPE.SET_IMPORT_FAQS:
      return { ...state, FAQs: action.payload };
    case DISPATCH_TYPE.SET_IMPORT_KEYWORDS:
      return { ...state, keywords: action.payload };
    case DISPATCH_TYPE.SET_IMPORT_STATUS:
      return { ...state, importStatus: action.payload };
    case DISPATCH_TYPE.SET_IMPORT_SECTIONS:
      return { ...state, sections: action.payload };
    case DISPATCH_TYPE.SET_IMPORT_QUESTION_TYPES:
      return { ...state, questionTypes: action.payload };
    case DISPATCH_TYPE.SET_IMPORT_DATE:
      return { ...state, importDate: action.payload };
    default:
      return state;
  }
}

export default importReducer;
